export const ErrorMessage = {
  DOWNLOAD_EXPORT_CHAT: "Chat file not found",
  DOWNLOAD_MEDIA_CHAT: "Chat Media file not found",
  DOWNLOAD_FAILED: "Download failed",
  IMAGE_NOT_FOUND: "Image not found",
  DOCUMENT_NOT_FOUND: "Document not found",
  SEND_REFERRAL_ERROR: "Oops! try sending referral after 1min",
};
